var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"unsubscribe-layout"},[_c('div',{staticClass:"unsubsribe-info-text"},[_vm._v(" You've been successfully unsubscribed. ")])])
}]

export { render, staticRenderFns }